import React from 'react'
import { useParams } from 'react-router-dom'
import queryString from 'query-string'
import SpinningLogo from 'components/pages/login/SpinningLogo'
import NewAuthTemplate from 'components/templates/NewAuthTemplate'
import SignUpProductReviewer from 'components/pages/signup/SignUpProductReviewer'
import SignUpReviewerOptions from 'components/pages/signup/SignUpReviewerOptions'
import useRedirectIfLoggedIn from 'hooks/useRedirectIfLoggedIn'
import FullScreenLoading from 'components/ui/FullScreenLoading'

const SignUpReviewer: React.FC = () => {
  const { loading } = useRedirectIfLoggedIn()

  const { productId } = useParams()
  const parsed = queryString.parse(location.search)

  const invitedById = parsed.invitedById ? parsed.invitedById.toString() : undefined

  const pageContent = (
    <>
      {productId && <SignUpProductReviewer productId={productId} invitedById={invitedById} />}
      {productId && <SignUpReviewerOptions productId={productId} />}
    </>
  )

  if (loading) return <FullScreenLoading />

  return <NewAuthTemplate container1={{ content: <SpinningLogo /> }} container2={{ content: pageContent }} />
}

export default SignUpReviewer
